module.exports = __webpack_public_path__ + "static/media/A (2).1d22d069.jpg";